import React from 'react';
import { Image } from 'semantic-ui-react';

const HeroPostMedia = ({ media }) => {
  let { hero_img } = media[0]
  return <Image src={hero_img} alt='' size='huge' />
}

export default HeroPostMedia;
